module.exports = __webpack_public_path__ + "img/logo_gamian.3dcc139d.png";